module.exports = {
  createCompany: 'Erstelle Firma',
  edit: 'Bearbeiten',
  activate: 'Aktivieren',
  deactivate: 'Deaktivieren',
  cancel: 'Abbrechen',
  create: 'Erstellen',
  update: 'Ändern',
  submit: 'Speichern',
  pay: 'Zahlen',
  paid: 'Bezahlt',
  clear: 'Löschen',
  selectTime: 'Zeit wählen',
  unpaid: 'Zwischenliste',
  moveItems: 'Artikel verschieben',
  save: 'Speichern',
  cancelTransaction: 'Transaktion abbrechen',
  open: 'Öffnen',
  openTable: 'Öffne Tisch',
  show: 'Zeige',
  select: 'Auswählen',
  selectTable: 'Tisch wählen',
  selectContact: 'Kontakt wählen',
  selectDate: 'Datum wählen',
  selectMethod: 'Methode wählen',
  selectTerminal: 'Terminal wählen',
  reprint: 'Nachdruck',
  back: 'Zurück',
  download: 'Download',
  cancellation: 'Storno',
  print: 'Druck',
  nullReceipt: 'Null Beleg',
  restaurant: 'Restaurant',
  takeaway: 'Mitnahme',
  collection: 'Abholung',
  delivery: 'Lieferung',
  createContact: 'Kontakt erstellen',
  editContact: 'Kontakt bearbeiten',
  createAddress: 'Addresse erstellen',
  delete: 'Löschen',
  close: 'Schließen',
  deleteContact: 'Kontakt löschen',
  yes: 'Ja',
  no: 'Nein',
  addItem: 'Artikel hinzufügen',
  none: 'Keine',
  searchContacts: 'Kontakt suchen',
  processPayment: 'Zahlung durchführen',
  success: 'Erfolg',
  signatureOk: 'Signatur OK',
  signatureFailed: 'Signatur fehlgeschlagen',
  selectPayment: 'Zahlung wählen',
  addPayment: 'Zahlung hinzufügen',
  chooseTime: 'Zeit wählen',
  openCashdrawer: 'Kassenschublade öffnen',
  setDefault: 'Als Standard setzen',
  reregister: 'Neuregistrierung',
  proceed: 'Fortsetzen',
  refreshTerminals: 'Terminals aktualisieren',
  generate: 'Generieren',
  exportType: 'Zu inkludierende Daten wählen:',
  backToOrder: 'Zurück zu Bestellung',
  noOfPrints: 'Anzahl Kopien',
  view: 'Anzeigen',
  viewAndPrint: 'Anzeigen und drucken',
  isAdded: 'wurde zum Warenkorb gefügt',
  lineOneSearch: 'Bitte Zeile 1 ebenfalls eingeben um Suche auszulösen.',
  clearBasket: 'Leeren',
  orderNow: 'Bestellen',
  refreshBtn: 'Aktualisieren',
  addDiscount: 'Rabatt hinzufügen',
  reload: 'Neu laden',
  enterPasswordp: 'Bitte neues Kennwort eingeben',
  newPassword: 'Neues Kennwort',
  confirmPassword: 'Kennwort Bestätigung',
  register: 'Registrieren',
  forgotPassword: 'Kennwort vergessen',
  send: 'Absenden',
  resetPassword: 'Kennwort zurücksetzen',
  addAddress: 'Addresse hinzufügen',
  checkout: 'Zur Kasse',
  calculate: 'Prüfen',
  preorder: 'Vorbestellen',
  click: 'Klick um',
  goBack: 'zurück',
  here: 'zu gehen',
  add: 'Hinzufügen',
  address: 'Adresse',
  placeOrder: 'Bestellung absenden',
  order: 'Bestellung',
  remove: 'Entfernen',
};



// WEBPACK FOOTER //
// ./src/lang/de/actions.js